<mat-toolbar color="warn">
    <div class="container d-flex flex-row align-items-center">
        <a routerLink="">
            <img src="../../../../assets/img/viessmann-white.svg" alt="Viessmann Logo" />
        </a>
        <span class="ms-3 mb-0 d-none d-sm-block">{{ appName }}</span>
    </div>
</mat-toolbar>
